<template>
    <div class="video-content">
        <div class="change-type" @click="change">
            {{ changeList[listactive].name }}
            <img src="@/assets/temimg15/change.png" alt="">
        </div>
        <div class="pic-list" v-show="listactive == 0">
            <div class="pic-item" v-for="item in videolist">
                <img :src="item.value2" alt="">
                <div class="pic-pos">
                    {{ item.value1 }}
                </div>
            </div>
        </div>
        <div class="ai-list" v-show="listactive == 1">
            <div class="sec-content">
                <el-input v-model="secval" size="small" class="sec-input" clearable placeholder="请输入问题关键字搜索"></el-input>
                <el-button type="primary" size="small" class="sec-btn" @click="quesSec">搜索</el-button>
            </div>
            <div class="sec-title">
                问题索引(滚动)
            </div>
            <div class="ques-content" @mouseenter="autoscroll = false" @mouseleave="autoscroll = true" ref="scrollCont">
                <div v-for="(item, i) in aiList" :key="i" class="ques-item">
                    {{ item.value1 }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as methods from "./method.js";
export default {
    name: 'template.scope123',
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            defaultdata: [
                {
                    value1: "位置",
                    value2: "http://121.4.173.197:8000/defaultimg/default1.jpg",
                    value3: "video",
                },
                {
                    value1: "位置2",
                    value2: "http://121.4.173.197:8000/defaultimg/default1.jpg",
                    value3: "video",
                },
                {
                    value1: "位置3",
                    value2: "http://121.4.173.197:8000/defaultimg/default1.jpg",
                    value3: "video",
                },
                {
                    value1: "位置4",
                    value2: "http://121.4.173.197:8000/defaultimg/default1.jpg",
                    value3: "video",
                },
                {
                    value1: '餐厅提供的食物有异常',
                    value2: '',
                    value3: 'list'
                },
                {
                    value1: '餐厅收费不合理，有霸王条款',
                    value2: '',
                    value3: 'list'
                },
                {
                    value1: '餐厅环境卫生很差',
                    value2: '',
                    value3: 'list'
                },
                {
                    value1: '餐厅收费不合理，有霸王条款',
                    value2: '',
                    value3: 'list'
                },
                {
                    value1: '餐厅的日常清洁有异常',
                    value2: '',
                    value3: 'list'
                },
            ],
            valueMap: [
                { name: "名称/问题描述", key: "value1" },
                { name: "地址", key: "value2" },
                { name: "所属类型(video/list)", key: "value3" },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            changeList: [
                { name: 'AI执法', key: 'video' },
                { name: '视频监控', key: 'list' }
            ],
            listactive: 0,
            videolist: [],
            aiList: [],
            secval: '',
            autoscroll: true,
            timer: null
        }
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                this.defaultdata = n;
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
        defaultdata(n) {
            this.setlist()
        }
    },
    methods: {
        ...methods,
        change() {
			this.$emit('titlechange', this.changeList[this.listactive].name, 2)
            if (this.listactive == 0) {
                this.listactive = 1
            } else {
                this.listactive = 0
            }
        },
        setlist() {
            this.videolist = this.defaultdata.filter(item => item.value3 == 'video')
            this.aiList = this.defaultdata.filter(item => item.value3 == 'list')
        },
        quesSec() {
            this.aiList = this.defaultdata.filter(item => item.value3 == 'list' && item.value1.includes(this.secval))
            setTimeout(() => {
                this.autoscr()
            }, 100);
        },
        autoscr() {
            if (this.aiList.length < 5) {
                clearInterval(this.timer)
                this.timer = null
                return
            }
            const ulf1 = this.$refs.scrollCont;
            if (ulf1.offsetHeight > 120) {
                ulf1.scrollTop = 0;
                this.timer = setInterval(this.rollStart, 150);
            } else if (ulf1.offsetHeight == 0) {
                setTimeout(() => {
                    this.autoscr();
                }, 150);
            }
        },
        rollStart() {
            if (!this.autoscroll) {
                return
            }
            const ulf1 = this.$refs.scrollCont;
            if (ulf1.scrollTop >= ulf1.scrollHeight - 160) {
                clearInterval(this.timer)
                this.timer = null
                setTimeout(() => {
                    ulf1.scrollTop = 0;
                    this.autoscr()
                }, 2000);
            } else {
                ulf1.scrollTop += 2;
            }
        },
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData(); //需要刷新的数据
        this.setlist()
        this.autoscr()
    },
    beforeDestroy() {
        clearInterval(this.timer)
        this.timer = null
    }
}
</script>

<style lang="scss" scoped>
.video-content {
    width: 435px;
    height: 240px;
    padding: 10px 0;
    position: relative;
    .change-type {
        position: absolute;
        right: 0px;
        top: -28px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #60A0FF;
        line-height: 15px;
        display: flex;
        align-items: center;
        margin: 0 21px 0 auto;
        cursor: pointer;
        img {
            width: 15px;
            height: 12px;
            margin-left: 8px;
        }
    }
    .pic-list {
        display: flex;
        flex-wrap: wrap;
        padding: 0 16px;
        box-sizing: border-box;
        row-gap: 8px;
        column-gap: 14px;
    }
    .pic-item {
        width: 188px;
        height: 114px;
        background: #000;
        border: 1px solid #0086C9;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        img {
            width: 98%;
            height: 95%;
        }
    }
    .pic-pos {
        position: absolute;
        bottom: 0;
        width: 196px;
        height: 25px;
        background: rgba(0,0,0,.6);
        text-align: center;
        line-height: 25px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
    }
    .sec-content {
        display: flex;
        align-items: center;
        .sec-btn {
            margin-left: 12px;
        }
    }
    .sec-title {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #0979F5;
        line-height: 15px;
        margin: 24px 0 12px 12px;
    }
    .ques-content {
        max-height: 160px;
        overflow: hidden;
    }
    .ques-item {
        padding: 12px 0 12px 16px;
        background: rgba(27, 112, 170, .05);
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #BCCCD3;
        line-height: 15px;
        &:nth-child(2n) {
            background: rgba(9, 121, 245, .16);
        }
    }
}
</style>
<style lang="scss">
.sec-content {
    .sec-input {
        .el-input__inner {
            background: rgba(9,121,245,0.18);
            border-radius: 3px;
            border: 1px solid #0979F5;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 13px;
            color: #5792E9;
            line-height: 13px;
        }
    }
}
</style>